import { useEffect } from 'react';
import {
  emmshopOrderPostToEcountApi,
  executeSchedulerPostApi,
  govshopOrderPostToEcountApi,
  itemUpdateApi,
  schedulerListGetApi,
  stockLatestUpdatedTimeGetApi,
  stockUpdateApi,
} from '../../../api/apiConfig';
import useFetch from '../../../api/useFetch';
import styled from 'styled-components';

export const DataManage = () => {
  const { fetch: fetchExecuteSchedulerPostApi } = useFetch({
    fetchFunction: executeSchedulerPostApi,
    onSuccess: () => undefined,
  });
  const { fetch: fetchStockLatestUpdatedTimeGetApi } = useFetch({
    fetchFunction: stockLatestUpdatedTimeGetApi,
  });

  const { fetch: fetchEmmshopOrderPostToEcountApi } = useFetch({
    fetchFunction: emmshopOrderPostToEcountApi,
    onSuccess: () => undefined,
  });

  const { fetch: fetchStockUpdateApi } = useFetch({
    fetchFunction: stockUpdateApi,
    onSuccess: () => undefined,
  });

  const { fetch: fetchItemUpdateApi } = useFetch({
    fetchFunction: itemUpdateApi,
    onSuccess: () => undefined,
  });

  const { fetch: fetchGovshopOrderPostToEcountApi } = useFetch({
    fetchFunction: govshopOrderPostToEcountApi,
    onSuccess: () => undefined,
  });

  useEffect(() => {
    fetchStockLatestUpdatedTimeGetApi();
  }, []);

  return (
    <Container>
      <Button onClick={() => fetchExecuteSchedulerPostApi()}>새로고침</Button>
      <Button onClick={() => fetchItemUpdateApi()}>품목 업데이트</Button>
      <Button onClick={() => fetchStockUpdateApi()}>재고 업데이트</Button>
      {/* <Button onClick={() => fetchGovshopOrderPostToEcountApi()}>
        나라장터 주문수집
      </Button> */}
      <Button onClick={() => fetchEmmshopOrderPostToEcountApi()}>
        자사쇼핑몰 주문수집
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Button = styled.div`
  width: 220px;
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  align-content: center;
  text-align: center;
  padding: 5px;
  font-weight: 600;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.blue_hover};
  }
`;
